import {
    DateRangePickerDashboardItemFactory,
    DateRangePickerDashboardItemFactoryOptions,
} from '../../../components/date-picker/date-range-picker';
import { FilterCategoryDashboardItemFactory, FilterCategoryDashboardItemFactoryOptions } from './filter/category-filter-dashboard-item/filter-category';
import {
    SegmentsDashboardItemFactory,
    SegmentsDashboardItemFactoryOptions,
} from './filter/segment-filter/segments';
import { StringInputFilterDashboardItemFactory, StringInputFilterDashboardItemFactoryOptions } from './filter/string-input-filter/string-input';
import {
    ModifyTimeDashboardItemFactory,
    ModifyTimeDashboardItemFactoryOptions,
} from './modify-time';
import {
    XYChartDashoardItemFactory,
    XYChartDashoardItemFactoryOptions,
} from './xy-chart';

export const commonFilterDashboardItemFactories = {
    'filter.category': (options: FilterCategoryDashboardItemFactoryOptions) =>
        new FilterCategoryDashboardItemFactory(options),
    'filter.daterange': (options: DateRangePickerDashboardItemFactoryOptions) =>
        new DateRangePickerDashboardItemFactory(options),
    'filter.segments': (options: SegmentsDashboardItemFactoryOptions) =>
        new SegmentsDashboardItemFactory(options),
    'filter.string_input': (options: StringInputFilterDashboardItemFactoryOptions) =>
        new StringInputFilterDashboardItemFactory(options),
};

export const commonChartDashboardItemFactories = {
    'common.chart.xy_chart': (options: XYChartDashoardItemFactoryOptions) =>
        new XYChartDashoardItemFactory(options),
    'common.modify_time': (options: ModifyTimeDashboardItemFactoryOptions) =>
        new ModifyTimeDashboardItemFactory(options),
};

export const DashboardItemFactories = {
    ...commonFilterDashboardItemFactories,
    ...commonChartDashboardItemFactories,
};
